import { useTheme as useNextTheme } from 'next-themes';
import { useEffect } from 'react';
import useUserStore from 'common/src/stores/useUserStore';

export function useTheme() {
  const { theme, setTheme } = useNextTheme();
  const { darkMode, setDarkMode } = useUserStore();

  // Sync persisted Zustand preference on mount
  useEffect(() => {
    if (darkMode && theme !== 'dark') {
      setTheme('dark');
    } else if (!darkMode && theme === 'dark') {
      setTheme('light');
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const isDark = theme === 'dark';

  const toggleTheme = () => {
    const newTheme = isDark ? 'light' : 'dark';
    setTheme(newTheme);
    setDarkMode(newTheme === 'dark');
  };

  return { isDark, toggleTheme };
}
